(function () {
  'use strict';

  var VISIBLE_MAP = {
    'スターター': [
      'Honey Yellow × Indigo Blue',
      'Honey Yellow × Sakura Pink',
      'Sakura Pink × Indigo Blue',
      'Yellow  Indigo Blue  Sakura Pink'
    ],
    '単色': [
      'Forest Green',
      'Honey Yellow',
      'Indigo Blue'
    ]
  };

  function filterOption2(selectedValue, variantSelects) {
    var allowed = VISIBLE_MAP[selectedValue] || [];
    var option2Wrapper = variantSelects.querySelector('[data-option-position="2"]');
    if (!option2Wrapper) return;

    option2Wrapper.querySelectorAll('.radio__button').forEach(function (span) {
      var input = span.querySelector('input[type="radio"]');
      if (!input) return;
      var isVisible = allowed.indexOf(input.value) !== -1;
      span.style.setProperty('display', isVisible ? '' : 'none', 'important');
    });

    // 非表示が選択中なら最初の表示中を選択
    var checkedInput = option2Wrapper.querySelector('input[type="radio"]:checked');
    var checkedSpan = checkedInput && checkedInput.closest('.radio__button');
    if (!checkedInput || (checkedSpan && checkedSpan.style.display === 'none')) {
      var first = null;
      option2Wrapper.querySelectorAll('.radio__button').forEach(function (span) {
        if (!first && span.style.display !== 'none') first = span;
      });
      if (first) {
        var inp = first.querySelector('input[type="radio"]');
        inp.checked = true;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function initForVariantSelects(vs) {
    var option1Wrapper = vs.querySelector('[data-option-position="1"]');
    var option2Wrapper = vs.querySelector('[data-option-position="2"]');
    if (!option1Wrapper || !option2Wrapper) return;

    var initialChecked = option1Wrapper.querySelector('input[type="radio"]:checked');
    if (initialChecked) filterOption2(initialChecked.value, vs);

    option1Wrapper.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        filterOption2(this.value, vs);
      });
    });
  }

  function init() {
    document.querySelectorAll('variant-selects').forEach(initForVariantSelects);
  }

  // DOMContentLoaded + 200ms待機でBroadcastの初期化完了を待つ
  function waitAndInit() {
    init();
    setTimeout(init, 200);
    setTimeout(init, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndInit);
  } else {
    waitAndInit();
  }

  document.addEventListener('theme:quick-add:open', function () {
    setTimeout(init, 100);
  });

  // variant-selectsの変化を監視（Broadcastが再レンダリングしても対応）
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.tagName === 'VARIANT-SELECTS') {
            initForVariantSelects(node);
          } else {
            node.querySelectorAll && node.querySelectorAll('variant-selects').forEach(initForVariantSelects);
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
